import api from '../../apiConfig/apiConfig';
import { Post, Get } from '../base/baseAjax';

// 开始检测
let siteSeoAnalysisStart = params => {
	return Post({
		url: api.siteSeoAnalysis.siteSeoAnalysisStart,
		UrlParam: params,
	});
};

// 获取检测结果
let siteSeoAnalysisResults = params => {
	return Get({
		url: api.siteSeoAnalysis.siteSeoAnalysisResults,
		PathParam: params,
	});
};

// 我的网站报告
let siteSeoAnalysisMySiteReport = params => {
	return Get({
		url: api.siteSeoAnalysis.siteSeoAnalysisMySiteReport,
		UrlParam: params,
	});
};

export default {
	siteSeoAnalysisStart,
	siteSeoAnalysisResults,
	siteSeoAnalysisMySiteReport,
};
